<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/usertypes">Users</a></li>
      <li class="breadcrumb-item active" aria-current="page">Contact Enquiry List</li>
    </ol>
  </nav>
</div>

<div class="container mt-1 themeTblReso">
  <div class="row">
    <div class="col-md-4" *ngIf="isSuperAdmin">
      <div>
        <select name="company" class="form-control formstyle" (change)="getcontactList()" [(ngModel)]="selectedCompany">
          <option value="">Select Company Name</option>
          <ng-container *ngFor="let userObj of getCompanyobj">
            <option *ngIf="userObj.dbstatus == true" value={{userObj.customer_id}}>
              {{ userObj.customer_company_name }}
            </option>
          </ng-container>
        </select>
      </div>
    </div>
    <div class="col-md-4">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
              aria-hidden="true"></i></span>
        </div>
        <input class="form-control" type="text" placeholder="Search" aria-label="Search" #searchText />
      </div>
    </div>

    <!-- <div class="col-md-4 mt-md-0 mt-2" style="justify-content: right">
      <input type="button" value="Add New" class="custbtn mt-md-1 mt-1 ml-0" routerLink="/corporate/add-res-category" />
    </div> -->
  </div>
  <div class="tblPrt">
    <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Created On</th>
        <th>Actions</th>
      </tr>
      <tr *ngFor="let conEle of contactObj">
     
        <td>{{conEle?.contact_fname}} {{conEle?.contact_lname}}</td>
        <td>{{conEle?.contact_email}}</td>
        <td>{{conEle?.contact_phone}}</td>
        <td>{{conEle?.createdon | date: "medium"}}</td>
      
        <td>
          <div class="actBtn">
            <i *ngIf="isRead" class="fa fa-eye mr-1 linkForce" (click)="gotodetail(conEle?.id)"></i>
          </div>
        </td>
      </tr>
    </table>
    <div *ngIf="resCusTotal == 0" style="text-align: center">
      <p>No Result Available</p>
    </div>
    <div class="mt-2 text-center difPagination" *ngIf="resCusTotal > 10">
      <ngb-pagination [collectionSize]="resCusTotal" [(page)]="slCatPage" [maxSize]="2" [rotate]="true"
        (pageChange)="getcontactList(slCatPage=$event)" aria-label="Custom pagination">
        <ng-template ngbPaginationPrevious>Prev</ng-template>
        <ng-template ngbPaginationNext>Next</ng-template>
      </ngb-pagination>
    </div>
  </div>
</div>
